import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Homepage from "./pages/Homepage";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Profile from "./pages/Profile";
import Leadership from "./pages/Leadership";
import IumrsEvent from "./pages/IcamEvent";
import News from "./pages/News";
import Payments from "./pages/Payments";
import LegalTerms from "./pages/LegalTerms"
import PrivacyPolicy from "./pages/LegalPolicy";
import IUMRSRegistration from "./components/events/iumrs-icam25/IUMRSRegistration";
import UnderConstruction from "./underConstruction";
import IUMRSFeeDetail from "./components/events/iumrs-icam25/IUMRSFeeDetails";
import IUMRSAbstract from "./components/events/iumrs-icam25/IUMRSAbstract";
import IUMRScommitee from "./components/events/iumrs-icam25/IUMRScommitee";
import IUMRSWorkshop from "./components/events/iumrs-icam25/PreWorshopDetail";
import SearchRedirect from "./hooks/SearchResultRedirect";
import PaymentInitialization from "./components/payments/paymentInitializationion";
import PaymentCallback from "./components/payments/PaymentCallback";
import Internationalcommitee from "./components/events/iumrs-icam25/InternationalCommitee";
import IUMRSAccommodation from "./components/events/iumrs-icam25/IUMRSAccommodation";
import SponsorPackage from "./components/events/iumrs-icam25/SponsorshipPackage";
import ConferenceVenue from "./components/events/iumrs-icam25/ConferenceVenue";
import PlenaryDetails from "./components/events/iumrs-icam25/PlenaryDetails";
import KeynoteSpeakers from "./components/events/iumrs-icam25/KeynoteSpeakers";
import InvitedSpeakers from "./components/events/iumrs-icam25/InvitedSpeakers";
import IUMRSGallery from "./components/events/iumrs-icam25/IUMRSGallery";
import JunWorkshop2026 from "./components/events/amrs-workshop-2026/JunWorkshop2026";
import DecWorkshop2026 from "./components/events/amrs-workshop-2026/DecWorkshop2026";
import EventRegisterPage from "./components/events/amrs-workshop-2026/EventRegisterPage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        {/* ------------------- */}
        <Route path="/signup/profile" element={<Profile />} />
        {/* ------------------- */}
        *<Route path="/news" element={<UnderConstruction />} />*
        {/* updating the leadership board */}
        <Route path="/blog" element={<UnderConstruction />}/>
        <Route path="/leadership/chief-patreon" element={<Leadership />} />
        <Route path="/payment-donations" element={<Payments/>}/>
        <Route path="/legal/terms-of-use" element= {<UnderConstruction />} />
        <Route path="/privacy-policy" element= {<UnderConstruction />} />


        {/*--------IUMRS-ICAM page----------*/}
        <Route path="/iumrs-icam25" element={<IumrsEvent />} />        
        <Route path="/iumrs-icam25/registration" element={<IUMRSRegistration />}/>
        <Route path="/iumrs-icam25/sponsorships" element={<SponsorPackage />} />
        <Route path="/iumrs-icam25/exhibitors" element={<UnderConstruction />} />
        <Route path="/iumrs-icam25/speakers/keynote" element={<KeynoteSpeakers />} />
        <Route path="/iumrs-icam25/speakers/invited" element={<InvitedSpeakers />} />
        <Route path="/iumrs-icam25/speakers/plenary" element={<PlenaryDetails />} />
        <Route path="/iumrs-icam25/workshop/winter-school" element={<IUMRSWorkshop />} />

        <Route path="/event/payment-initializer" element={<PaymentInitialization />} />
        <Route path="/iumrs-icam25/registration-fee" element={<IUMRSFeeDetail />}/>
        <Route path="/iumrs-icam25/abstract-submission" element={<IUMRSAbstract />}/>
        <Route path="/iumrs-icam25/conference-venue" element={<ConferenceVenue />}/>
        <Route path="/iumrs-icam25/organising-commitee" element={<IUMRScommitee />}/>
        <Route path="/iumrs-icam25/travel-details" element={<SearchRedirect searchTerms="Embassy of Ghana" />}/>
        <Route path="/event/payment-verification" element={<PaymentCallback />}/>
        <Route path="/iumrs-icam25/international-commitee" element={<Internationalcommitee />} />
        <Route path="/iumrs-icam25/accomodation" element={<IUMRSAccommodation />} />
        <Route path="/iumrs-icam25/gallery" element={<IUMRSGallery />} />

        
        {/*-------Workshop pages. Fix: Refactor to retrieve properties and values from utils-------*/}
        {/*-----------------------June 2026 Workshop-------------------*/}
        <Route path="/amrs-jun-2026-workshop" element={<JunWorkshop2026 />} />
        {/*<Route path="/amrs-jun-2026-workshop/register" element={<WorkshopRegisterPage />} />*/}
        <Route path="amrs-jun-2026-workshop/register" element={<EventRegisterPage 
        backHref={"/amrs-jun-2026-workshop"}
        registerEndpoint={"/event/workshop/amrs-jun-2026-workshop/register"}
        paymentEndpoint={"/event/workshop/amrs-jun-2026-workshop/payment-request"}
        mandatoryCourses={[{ id: 'c1', name: '3D Design & Printing', tag: 'Mandatory', mandatory: true }, { id: 'c2', name: 'MATLAB', tag: 'Mandatory', mandatory: true }]}
        optionalCourses={
          [
            { id: 'c3', name: 'Solar Power Design & Testing' },
            { id: 'c4', name: 'DFT Modelling' },
            { id: 'c5', name: 'ABAQUS Modelling' },
            { id: 'c6', name: 'COMSOL Multiphysics' },
            { id: 'c7', name: 'Phase-Field Modelling' }
        ]}
        fee = {{ type: 'flat', amount: 500, currency: 'GH₵', note: 'One-time · Full 3-day access',}}
        />} />

        {/*-----------------------December 2026 Workshop-------------------*/}
        <Route path="/amrs-dec-2026-workshop" element={<DecWorkshop2026 />} />
        <Route path="amrs-dec-2026-workshop/register" element={<EventRegisterPage 
        backHref={"/amrs-dec-2026-workshop"}
        registerEndpoint={"/event/workshop/amrs-dec-2026-workshop/register"}
        paymentEndpoint={"/event/workshop/amrs-dec-2026-workshop/payment-request"}
        mandatoryCourses={[{id: 1, name: "MATLAB & ML", mandatory: true, tag: "Mandatory"}]}
        optionalCourses={
          [
            { id: 2, name: "Solar Power Design and Testing" },
            { id: 3, name: "DFT Calculation" },
            { id: 4, name: "Abaqus CAE" },
            { id: 5, name: "COMSOL Multiphysics"}
        ]}
        fee={{type: 'tiered', note: 'One-time · Full access', deadline: 'November 23, 2026', tiers: [
          { isStudent: true,  isInternational: false, amount: 500, currency: 'GH₵' },
          { isStudent: false, isInternational: false, amount: 750, currency: 'GH₵' },
          { isStudent: true,  isInternational: true,  amount: 200, currency: 'USD' },
          { isStudent: false, isInternational: true,  amount: 300, currency: 'USD' },
          ],}}
        />} />
        ///
      </Routes>
    </BrowserRouter>
  );
}

export default App;